import axios from 'axios';

// API 기본 URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/**
 * 공개 API 클라이언트 (인증 불필요)
 * URL에서 tenantId와 token을 받아서 사용
 */
export const createPublicApiClient = (tenantId) => {
  return axios.create({
    baseURL: API_URL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
      'x-tenant-id': tenantId
    }
  });
};

/**
 * 공개 API 호출 헬퍼
 */
export const publicAPI = {
  /**
   * 수업일지 조회
   * @param {string} tenantId - 학원 ID (URL에서 추출)
   * @param {string} lessonId - 수업일지 ID
   * @param {string} token - 토큰
   */
  getLesson: (tenantId, lessonId, token) => {
    const client = createPublicApiClient(tenantId);
    return client.get(`/api/public/lessons/${lessonId}`, {
      params: { token }
    });
  },

  /**
   * 주간 리포트 조회
   * @param {string} tenantId - 학원 ID
   * @param {string} reportId - 리포트 ID
   * @param {string} token - 토큰
   */
  getWeeklyReport: (tenantId, reportId, token) => {
    const client = createPublicApiClient(tenantId);
    return client.get(`/api/public/reports/weekly/${reportId}`, {
      params: { token }
    });
  },

  /**
   * 월간 리포트 조회
   * @param {string} tenantId - 학원 ID
   * @param {string} reportId - 리포트 ID
   * @param {string} token - 토큰
   */
  getMonthlyReport: (tenantId, reportId, token) => {
    const client = createPublicApiClient(tenantId);
    return client.get(`/api/public/reports/monthly/${reportId}`, {
      params: { token }
    });
  },

  /**
   * 공지사항 조회
   * @param {string} tenantId - 학원 ID
   * @param {string} noticeId - 공지사항 ID
   * @param {string} token - 토큰
   */
  getNotice: (tenantId, noticeId, token) => {
    const client = createPublicApiClient(tenantId);
    return client.get(`/api/public/notice/${noticeId}`, {
      params: { token }
    });
  },

  /**
   * 수업일정 조회
   * @param {string} tenantId - 학원 ID
   * @param {string} scheduleId - 일정 ID
   * @param {string} token - 토큰
   */
  getSchedule: (tenantId, scheduleId, token) => {
    const client = createPublicApiClient(tenantId);
    return client.get(`/api/public/schedule/${scheduleId}`, {
      params: { token }
    });
  }
};

export default publicAPI;
